// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2jhCu","header":"MergedInvoice_header__3OwsJ"};